import Vue from 'vue';

export default [
    {
        pathId: 'rs',
        component: 'resellers',
        title: 'Resellers',
        icon: 'fa-user-tie',
        size: 'sm', //sm, md, lg, xl
        loading: true
    }, {
        pathId: 'rqs',
        component: 'reseller-quotes',
        title: 'Reseller Quotes',
        icon: 'fa-file-invoice-dollar',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        loading: true
    }, {
        pathId: 'rqcs',
        component: 'completed-quotes',
        title: 'Completed Quotes',
        icon: 'fa-file-invoice-dollar',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        loading: true
    }, {
        pathId: 'rqn',
        component: 'new-reseller-quote',
        title: 'New Quote',
        icon: 'fa-plus',
        size: 'lg' //sm, md, lg, xl
    }, {
        pathId: 'rqe',
        component: 'edit-reseller-quote',
        title: 'Edit Quote',
        icon: 'fa-pencil',
        size: 'lg', //sm, md, lg, xl
        loading: true,
        props: ['quoteId']
    }, {
        pathId: 'rqp',
        component: 'prepare-plan',
        title: 'Prepare Plan',
        icon: 'fa-file-pdf',
        size: 'lg', //sm, md, lg, xl
        loading: true,
        props: ['quoteId']
    }, {
        pathId: 'rqc',
        component: 'prepare-cart',
        title: 'Prepare Cart',
        icon: 'fa-shopping-cart',
        size: 'lg', //sm, md, lg, xl
        loading: true,
        props: ['quoteId']
    }, {
        pathId: 'rrer',
        component: 'reseller-enroll-report',
        title: 'Enrollment Referral Report',
        icon: 'fa-clipboard-check',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['userId']
    }, {
        pathId: 'rdb',
        component: 'reseller-client-database',
        title: 'Client Database',
        icon: 'fa-users',
        size: 'md', //sm, md, lg, xl
        loading: true,
    }, {
        pathId: 'rcs',
        component: 'reseller-client-search',
        title: 'Client Seafch',
        icon: 'fa-duotone fa-magnifying-glass',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['query']
    }
, {
        pathId: 'ra',
        component: 'reseller-activity',
        title: 'Reseller Activity',
        icon: 'fa-chart-line',
        size: 'lg',
        loading: true,
        props: ['resellerId']
    }, {
        pathId: 'r',
        component: 'reseller',
        title: 'Reseller',
        icon: 'fa-user-tie',
        size: 'md',
        loading: true,
        props: ['resellerId']
    }
];

Vue.component('reseller', () => import('@/cards/reseller/Reseller'));
Vue.component('resellers', () => import('@/cards/reseller/Resellers'));
Vue.component('reseller-quotes', () => import('@/cards/reseller/Quotes'));
Vue.component('completed-quotes', () => import('@/cards/reseller/CompletedQuotes'));
Vue.component('new-reseller-quote', () => import('@/cards/reseller/NewQuote'));
Vue.component('edit-reseller-quote', () => import('@/cards/reseller/EditQuote'));
Vue.component('prepare-plan', () => import('@/cards/reseller/PreparePlan'));
Vue.component('prepare-cart', () => import('@/cards/reseller/PrepareCart'));
Vue.component('reseller-enroll-report', () => import('@/cards/reseller/EnrollmentReport'));
Vue.component('reseller-client-database', () => import('@/cards/reseller/ResellerClientDatabase'));
Vue.component('reseller-client-search', () => import('@/cards/reseller/ResellerClientSearch'));
Vue.component('reseller-activity', () => import('@/cards/reseller/ResellerActivity'));
